import React from "react";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import Image from "next/image";
import Link from "next/link";
import AOS from "aos";

import Pro05 from "@/public/static/images/project_05.jpg";
import Pro06 from "@/public/static/images/project_06.png";
import Pro07 from "@/public/static/images/project_07.png";
import Pro08 from "@/public/static/images/project_08.png";
import Pro09 from "@/public/static/images/project_09.png";

function welcomeapp() {
  AOS.init({
    offset: 200,
    duration: 600,
    easing: "ease-in-out-sine",
    delay: 200,
    mirror: true,
  });
  return (
    <div className="wrapper">
      <Header />
      <section className="proj">
        <div className="container">
          <div className="row">
            <div className="col-12 project_box">
              <div className="row">
                <div className="col-12 col-md-7 order-md-1 order-2">
                  <div>
                    <div className="project-heading">
                      <h1 className="t-pink">Welcome Application</h1>
                    </div>
                  </div>
                  {/* <div className="badge_box">
                    <Link href="/ourservice/web_application">
                      <span className="badge rounded-pill text-bg-light">
                        Android Application Development
                      </span>
                    </Link>
                  </div> */}
                  <div className="project-list">
                    <ul>
                      <li>Record company’s visitors information</li>
                      <li>Employee's privacy concern</li>
                      <li>Convenience</li>
                      <li>Task reduction for employees</li>
                    </ul>
                  </div>
                </div>
                <div className="col-12 col-md-5 order-md-2 order-1">
                  <Image
                    loading="lazy"
                    src={Pro05}
                    alt="ITP SUITE APPLICATION"
                    className="img-fluid mx-auto "
                  />
                </div>
              </div>
            </div>

            <div className="col-12 d-none d-sm-block project_content">
              <div className="row mb-5">
                <div className="col-12 col-md-6 mb-3 project_content-inner">
                  <Image
                    loading="lazy"
                    src={Pro06}
                    alt="ITP SUITE APPLICATION"
                    className="img-fluid mx-auto "
                  />
                </div>
                <div className="col-12 col-md-6 mb-3 project_content-inner">
                  <h2 className="t-pink mb-2">Function</h2>
                  <p>
                    - Keyword (name, department etc.) search
                    <br />
                    - Photo shooting
                    <br />
                    - Call by phone, LINE
                    <br />
                  </p>
                </div>
              </div>

              <div className="row mb-5">
                <div className="col-12 col-md-6 mb-3 project_content-inner">
                  <Image
                    loading="lazy"
                    src={Pro07}
                    alt="ITP SUITE APPLICATION"
                    className="img-fluid mx-auto "
                  />
                </div>
                <div className="col-12 col-md-6 mb-3 project_content-inner">
                  <h2 className="t-pink mb-2">Background</h2>
                  <p className="mb-3">
                    1. At ITP Asia, we receive a high volume of visitors on a
                    daily basis including both scheduled and unscheduled
                    appointments but no record of visitor.
                  </p>
                  <p className="mb-3">
                    2. To protect the safety and privacy of our employees,
                    visitors are not permitted to enter the office without prior
                    permission. Therefore, it is crucial to have a tool in place
                    that can facilitate this process effectively and reduce
                    human task as much as possible.
                  </p>
                  <p className="mb-3">
                    3. This tool must be able to accurately inform the exact
                    employee of the visitor's arrival while maintaining their
                    personal privacy. Additionally, it should provide the
                    employee with the option to decline the meeting with the
                    visitor if necessary too.
                  </p>
                </div>
              </div>
              <div className="row mb-5">
                <div className="col-12 col-md-6 mb-3 project_content-inner">
                  <Image
                    loading="lazy"
                    src={Pro08}
                    alt="ITP SUITE APPLICATION"
                    className="img-fluid mx-auto "
                  />
                  <Image
                    loading="lazy"
                    src={Pro09}
                    alt="ITP SUITE APPLICATION"
                    className="img-fluid mx-auto "
                  />
                </div>
                <div className="col-12 col-md-6 mb-3 project_content-inner">
                  <h2 className="t-pink mb-2">Result</h2>
                  <p className="mb-3">
                    1. To address the need as the problem we found, our Welcome
                    Application offers a solution. By implementing this tool,
                    there is no need to hire receptionists for greeting
                    visitors, as the application can efficiently take on t his
                    task on your behalf.
                  </p>
                  <p className="mb-3">
                    2. Upon arrival at the office, visitors can select the
                    employee they wish to meet from the Welcome Application's
                    interface. The next step involves providing necessary
                    information before meeting the employees. Our Welcome
                    Application can promptly connect visitors to the employee
                    through various methods, including Microsoft Teams
                    application, LINE, or direct call.
                  </p>
                  <p className="mb-3">
                    3. Additionally, any personal information, either of the
                    visitor or employees, is securely stored in the
                    application's database and not accessible to those who are
                    not allowed to.
                  </p>
                  <p className="mb-3">
                    4. We also design and deliver with a CMS as a full package
                    so that the user can easily access, collect, and manage all
                    the data related to the process. Making it user-friendly
                    that anyone in your office can do with less time consumer.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 d-block d-sm-none project_content">
              <div className="row mb-5">
                <div className="col-12 col-md-6 mb-3 project_content-inner">
                  <h2 className="t-pink mb-2">Function</h2>
                  <p>
                    - Keyword (name, department etc.) search
                    <br />
                    - Photo shooting
                    <br />
                    - Call by phone, LINE
                    <br />
                  </p>
                </div>
                <div className="col-6 col-md-6 mb-3 project_content-inner">
                  <Image
                    loading="lazy"
                    src={Pro06}
                    alt="ITP SUITE APPLICATION"
                    className="img-fluid mx-auto "
                  />
                </div>
                <div className="col-6 col-md-6 mb-3 project_content-inner">
                  <Image
                    loading="lazy"
                    src={Pro07}
                    alt="ITP SUITE APPLICATION"
                    className="img-fluid mx-auto "
                  />
                </div>
                <div className="col-6 col-md-6 mb-3 project_content-inner">
                  <Image
                    loading="lazy"
                    src={Pro08}
                    alt="ITP SUITE APPLICATION"
                    className="img-fluid mx-auto "
                  />
                </div>
                <div className="col-6 col-md-6 mb-3 project_content-inner">
                  <Image
                    loading="lazy"
                    src={Pro09}
                    alt="ITP SUITE APPLICATION"
                    className="img-fluid mx-auto "
                  />
                </div>
                <div className="col-12 col-md-6 mb-3 project_content-inner">
                  <h2 className="t-pink mb-2">Background</h2>
                  <p className="mb-3">
                    1. At ITP Asia, we receive a high volume of visitors on a
                    daily basis including both scheduled and unscheduled
                    appointments but no record of visitor.
                  </p>
                  <p className="mb-3">
                    2. To protect the safety and privacy of our employees,
                    visitors are not permitted to enter the office without prior
                    permission. Therefore, it is crucial to have a tool in place
                    that can facilitate this process effectively and reduce
                    human task as much as possible.
                  </p>
                  <p className="mb-3">
                    3. This tool must be able to accurately inform the exact
                    employee of the visitor's arrival while maintaining their
                    personal privacy. Additionally, it should provide the
                    employee with the option to decline the meeting with the
                    visitor if necessary too.
                  </p>
                </div>
                <div className="col-12 col-md-6 mb-3 project_content-inner">
                  <h2 className="t-pink mb-2">Result</h2>
                  <p className="mb-3">
                    1. To address the need as the problem we found, our Welcome
                    Application offers a solution. By implementing this tool,
                    there is no need to hire receptionists for greeting
                    visitors, as the application can efficiently take on t his
                    task on your behalf.
                  </p>
                  <p className="mb-3">
                    2. Upon arrival at the office, visitors can select the
                    employee they wish to meet from the Welcome Application's
                    interface. The next step involves providing necessary
                    information before meeting the employees. Our Welcome
                    Application can promptly connect visitors to the employee
                    through various methods, including Microsoft Teams
                    application, LINE, or direct call.
                  </p>
                  <p className="mb-3">
                    3. Additionally, any personal information, either of the
                    visitor or employees, is securely stored in the
                    application's database and not accessible to those who are
                    not allowed to.
                  </p>
                  <p className="mb-3">
                    4. We also design and deliver with a CMS as a full package
                    so that the user can easily access, collect, and manage all
                    the data related to the process. Making it user-friendly
                    that anyone in your office can do with less time consumer.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default welcomeapp;
